import React from 'react';
import PropTypes from 'prop-types';
import Bubble from 'react-bubble';
import Immutable from 'immutable';

/** Just a component made as a simple wrapper around UserFieldDataTypeEnum.js's createInputElement, so that the syntax gets a bit prettier
 *  for the callers (a JSX-tag instead of a method call).
 *
 *  In addition to this, it has some additional simple capabilities, such as being able to automatically validate and show error message if validation error.
 *  (Again, just using the UserFieldDataType-enum methods).
 *
 *  Props:
 *      dataType             = one of the entries in the UserFieldDataType-enum (from UserFieldDataTypeEnum.js)
 *      options              = (optional for some dataTypes) the options to the dataType
 *      isError              = (optional if autoCheckErrors is true)
 *      autoCheckErrors      = (optional is isError is given) (assumes value-prop contains the value) (is false by default, since the caller might want to synchronize the error variable with this one.... perhaps it should always be autodetect, but this makes the callers error very visible...)
 *      errorMessageOverride = (optional) If you want to use a different error message than the default.
 *      required             = (optional) If true, a field value must be provided.
 *      hideErrWhenFocused   = (optional) If true, the field is not validated while focused (to avoid fields being highlighted as invalid until fully entered). Do not use for date and datetime fields as calendar will be hidden.
 *      hideErrUntilFocused  = (optional) If true, the field is not validated until after first focus (to avoid initial blank fields to be highlighted as invalid). Do not use for date and datetime fields as calendar will be hidden.
 *      resetStateKey        = (optional) Used to reset the "focused" and "visited" state. When this value changes, we reset the focused and visited values to default. This allows to reset the form, if we're not navigating away from the page, without "field must have a value" error messages.
 *      ...the rest...       = will be given to the component from UserFieldDataType.createInputElement()
 *
 *  TODO: I just quickly selected the "react-bubble" library to show the errors. Perhaps that is not the prettiest or best. (forcing to set width/height for example...)
 */
export default class UserFieldElement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            focused: false,
            visited: false
        }
    };

    static propTypes = {
        dataType: PropTypes.object.isRequired,
        options: PropTypes.array, //.isRequired,
        isError: PropTypes.bool, // optional if autoCheckErrors is given and is true
        autoCheckErrors: PropTypes.bool, // optional if isError is given
        errorMessageOverride: PropTypes.string, // optional
        required: PropTypes.bool, // optional
        hideErrWhenFocused: PropTypes.bool, // optional
        hideErrUntilFocused: PropTypes.bool, // optional
        resetStateKey: PropTypes.number, // optional
        errorWidth: PropTypes.string, // optional
        errorHeight: PropTypes.string, // optional
        errorStyle: PropTypes.object, // optional
        containerClassName: PropTypes.string, // optional
        hideErrorIfDisabled: PropTypes.bool,
    };

    static defaultProps = {
        required: false,
        hideErrorIfDisabled: false,
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.resetStateKey && nextProps.resetStateKey !== this.props.resetStateKey)
            this.setState({focused: false, visited: false});
    }

    isValid = () => {
        let result = (this.props.autoCheckErrors
            ? (
                this.props.required && (this.props.value===null || this.props.value=="") ? false :
                this.props.required==false && (this.props.value===null || this.props.value=="") ? true :
                this.props.pattern && !(new RegExp(this.props.pattern)).test(this.props.value) ? false :
                this.props.isError ? false :
                this.props.dataType.isCompatibleValue(this.props.value, this.props.options)
            )
            : !this.props.isError);
        return (result);
    };

    render() {
        const dataType = this.props.dataType;
        const options = this.props.options;
        const errorMessageOverride = this.props.errorMessageOverride;
        const isError =
            this.props.hideErrUntilFocused && !this.state.visited ? false
            : this.props.hideErrWhenFocused && this.state.focused ? false
            : !this.isValid();
        const propsToPassAlong = Object.assign({}, this.props);
        delete propsToPassAlong.dataType;
        delete propsToPassAlong.options;
        delete propsToPassAlong.isError;
        delete propsToPassAlong.errorMessageOverride;
        delete propsToPassAlong.autoCheckErrors;
        delete propsToPassAlong.required;
        delete propsToPassAlong.hideErrWhenFocused;
        delete propsToPassAlong.hideErrUntilFocused;
        delete propsToPassAlong.resetStateKey;
        delete propsToPassAlong.errorWidth;
        delete propsToPassAlong.errorHeight;
        delete propsToPassAlong.errorStyle;
        delete propsToPassAlong.containerClassName;

        if (typeof(propsToPassAlong.onFocus) == "undefined" && (this.props.hideErrWhenFocused)) propsToPassAlong.onFocus = ()=>{this.setState({focused: true});};
        if (typeof(propsToPassAlong.onBlur) == "undefined" && (this.props.hideErrWhenFocused || this.props.hideErrUntilFocused)) propsToPassAlong.onBlur = ()=>{this.setState({focused: false, visited: true});};

        if (isError) {
            if (typeof(propsToPassAlong.className) == "undefined") propsToPassAlong.className = "";
            propsToPassAlong.className += " validation-error";
        }

        const element = dataType.createInputElement(propsToPassAlong, options);
        const errorTextElement = !isError || (this.props.disabled === true && this.props.hideErrorIfDisabled === true) ? "" :
            <Bubble width={this.props.errorWidth ? this.props.errorWidth : 256} height={"auto"} style={this.props.errorStyle ? this.props.errorStyle : {container: {zIndex: 99, minHeight:45}}}>
                <div style={{padding:10}}>
                    {this.props.autoCheckErrors && this.props.required && (this.props.value===null || this.props.value=="") ? "Skal være udfyldt." //"Must have a value."
                        : errorMessageOverride ? errorMessageOverride
                        : dataType.getErrorMessage()}
                </div>
            </Bubble>;

        return (
            <div className={"user-field-element" + (this.props.containerClassName ? ' ' + this.props.containerClassName : '')}>
                {element}
                {errorTextElement}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/src/components/reusable/UserFieldElement.js